import React from 'react';
import { graphql } from 'gatsby';
import Container from '../../layout/container/container';
import Spacing from '../../layout/spacing/spacing';
import Grid from '../../layout/grid/grid';
import Svg from '../../svg/svg';
import HomeHero from '../../home-hero/home-hero';

const LogoBlock = ({ paddingTop, paddingBottom, background, ...props }) => {

  const words = [
    'same same or',
  ];

  return (
    <Container gutters bg={background}>
        <Container size="lg">
            <HomeHero smaller headingWords={words} />
        </Container>
    </Container>
  );
};

export default LogoBlock;

export const query = graphql`
  fragment LogoBlock on DatoCmsLogoBlock {
    id: originalId
    paddingTop
    paddingBottom
    background
    __typename
  }
`;
